// Définition des flèches personnalisées pour le carousel Slick
var prevArrow = 
`<div class="p-[10px] slick-arrow--left absolute bg-secondary rounded-full top-[50%] translate-y-[-50%] w-[26px] h-[26px] left-[-40px]  3xl:left-[40px] 2xl:left-[30px] md:h-[30px] md:w-[30px] md:p-[8px] z-[2] cursor-pointer lg:left-[15px] rotate-180"><svg class="" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none"><path class="fill-primary" fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490958 12.0585 0.907769 12.0585 1.16486 11.8245L6.61394 6.86636C6.73591 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73591 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112943 0.664032 1.51006e-05C0.492182 -0.00109923 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.087623 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674706 0.515396 1.85053e-05 0.595544C-0.000637695 0.675692 0.0161644 0.755113 0.0493842 0.82889C0.0826041 0.902667 0.131534 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.0904164 11.17C0.05721 11.2428 0.0400853 11.3213 0.0400853 11.4006C0.0400853 11.4799 0.05721 11.5584 0.0904164 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/></svg></div>`;

var nextArrow = `<div class="slick-arrow--right absolute bg-secondary rounded-full top-[50%] translate-y-[-50%] w-[26px] h-[26px] p-[10px] 3xl:right-[40px] 2xl:right-[30px] md:h-[30px] md:w-[30px] md:p-[8px] z-[2] cursor-pointer lg:right-[15px]"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490958 12.0585 0.907769 12.0585 1.16486 11.8245L6.61394 6.86636C6.73591 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73591 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112943 0.664032 1.51006e-05C0.492182 -0.00109923 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.087623 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674706 0.515396 1.85053e-05 0.595544C-0.000637695 0.675692 0.0161644 0.755113 0.0493842 0.82889C0.0826041 0.902667 0.131534 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.0904164 11.17C0.05721 11.2428 0.0400853 11.3213 0.0400853 11.4006C0.0400853 11.4799 0.05721 11.5584 0.0904164 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/></svg></div>`;

// ============================================================================
// FONCTIONS COMMENTÉES (ANCIENNES VERSIONS SLICK)
// ============================================================================

/*
// Ancienne version Slick pour les produits best sellers
window.initSlickProducts = function() {
  const $list = $('.slider-search__best-sellers ul.aa-List');
  if (!$list.length || $list.hasClass('slick-initialized')) return;

  const fakeSlide = `
    <li class="aa-Item">
      <div class="aa-ProductItem aa-ProductItem--view-all">
        <see-all-button section="showBestSellers150" class="aa-ProductLink">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <g clip-path="url(#clip0_2457_3667)">
              <path d="M23.8628 5.68132C24.4873 5.68132 25 5.16856 25 4.54397V3.40934C25 1.53284 23.4646 0 21.591 0H7.95244C6.07614 0 4.54347 1.53284 4.54347 3.40934V4.54669H3.40897C1.53267 4.54669 0 6.07953 0 7.95603V21.5934C0 23.4699 1.53267 25.0027 3.40897 25.0027H17.0448C18.9211 25.0027 20.4538 23.4699 20.4538 21.5934V20.456H21.591C23.4673 20.456 25 18.9232 25 17.0467V9.09339C25 8.4688 24.4873 7.95603 23.8628 7.95603C23.2382 7.95603 22.7255 8.4688 22.7255 9.09339V17.0494C22.7255 17.674 22.2128 18.1868 21.5883 18.1868H7.95244C7.32792 18.1868 6.81521 17.674 6.81521 17.0494V3.40934C6.81521 2.78475 7.32792 2.27198 7.95244 2.27198H21.5883C22.2128 2.27198 22.7255 2.78475 22.7255 3.40934V4.54669C22.7255 5.17128 23.2355 5.68132 23.86 5.68132H23.8628ZM7.95244 20.456H18.1793V21.5934C18.1793 22.218 17.6666 22.7307 17.0421 22.7307H3.40897C2.78444 22.7307 2.27174 22.218 2.27174 21.5934V7.9533C2.27174 7.32871 2.78444 6.81595 3.40897 6.81595H4.5462V17.044C4.5462 18.9205 6.07887 20.4533 7.95517 20.4533L7.95244 20.456ZM13.6359 14.2047V11.3626H10.7942C10.1696 11.3626 9.65692 10.8499 9.65692 10.2253C9.65692 9.6007 10.1696 9.08793 10.7942 9.08793H13.6359V6.24591C13.6359 5.62132 14.1486 5.10855 14.7731 5.10855C15.3976 5.10855 15.9103 5.62132 15.9103 6.24591V9.08793H18.752C19.3766 9.08793 19.8893 9.6007 19.8893 10.2253C19.8893 10.8499 19.3766 11.3626 18.752 11.3626H15.9103V14.2047C15.9103 14.8293 15.3976 15.342 14.7731 15.342C14.1486 15.342 13.6359 14.8293 13.6359 14.2047Z" fill="#1E1E1E" fill-opacity="0.4"/>
            </g>
            <defs>
              <clipPath id="clip0_2457_3667">
                <rect width="25" height="25" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <div class="aa-ProductTitle">Voir tous les produits</div>
        </see-all-button>
      </div>
    </li>
  `;

  $list.on('init', function(event, slickInstance) {
    slickInstance.slickAdd(fakeSlide);
  });

  $list.slick({
    slidesToShow: 5.3,
    slidesToScroll: 3,
    infinite: false,
    arrows: true,
    prevArrow,
    nextArrow,
    variableWidth: false,
    centerMode: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 767,      
        settings: {
          slidesToShow: 2.7,    
          slidesToScroll: 3,
          arrows: false       
        }
      }
    ]
  });
};

// Ancienne version Slick pour les produits best sellers results
window.initSlickProductsResults = function() {
  const $list = $('.slider-search__best-sellers-results ul.aa-List');
  if (!$list.length || $list.hasClass('slick-initialized')) return;

  const fakeSlide = `
    <li class="aa-Item">
      <div class="aa-ProductItem aa-ProductItem--view-all">
        <see-all-button section="showBestSellers150" class="aa-ProductLink">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <g clip-path="url(#clip0_2457_3667)">
              <path d="M23.8628 5.68132C24.4873 5.68132 25 5.16856 25 4.54397V3.40934C25 1.53284 23.4646 0 21.591 0H7.95244C6.07614 0 4.54347 1.53284 4.54347 3.40934V4.54669H3.40897C1.53267 4.54669 0 6.07953 0 7.95603V21.5934C0 23.4699 1.53267 25.0027 3.40897 25.0027H17.0448C18.9211 25.0027 20.4538 23.4699 20.4538 21.5934V20.456H21.591C23.4673 20.456 25 18.9232 25 17.0467V9.09339C25 8.4688 24.4873 7.95603 23.8628 7.95603C23.2382 7.95603 22.7255 8.4688 22.7255 9.09339V17.0494C22.7255 17.674 22.2128 18.1868 21.5883 18.1868H7.95244C7.32792 18.1868 6.81521 17.674 6.81521 17.0494V3.40934C6.81521 2.78475 7.32792 2.27198 7.95244 2.27198H21.5883C22.2128 2.27198 22.7255 2.78475 22.7255 3.40934V4.54669C22.7255 5.17128 23.2355 5.68132 23.86 5.68132H23.8628ZM7.95244 20.456H18.1793V21.5934C18.1793 22.218 17.6666 22.7307 17.0421 22.7307H3.40897C2.78444 22.7307 2.27174 22.218 2.27174 21.5934V7.9533C2.27174 7.32871 2.78444 6.81595 3.40897 6.81595H4.5462V17.044C4.5462 18.9205 6.07887 20.4533 7.95517 20.4533L7.95244 20.456ZM13.6359 14.2047V11.3626H10.7942C10.1696 11.3626 9.65692 10.8499 9.65692 10.2253C9.65692 9.6007 10.1696 9.08793 10.7942 9.08793H13.6359V6.24591C13.6359 5.62132 14.1486 5.10855 14.7731 5.10855C15.3976 5.10855 15.9103 5.62132 15.9103 6.24591V9.08793H18.752C19.3766 9.08793 19.8893 9.6007 19.8893 10.2253C19.8893 10.8499 19.3766 11.3626 18.752 11.3626H15.9103V14.2047C15.9103 14.8293 15.3976 15.342 14.7731 15.342C14.1486 15.342 13.6359 14.8293 13.6359 14.2047Z" fill="#1E1E1E" fill-opacity="0.4"/>
            </g>
            <defs>
              <clipPath id="clip0_2457_3667">
                <rect width="25" height="25" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <div class="aa-ProductTitle">Voir tous les produits</div>
        </see-all-button>
      </div>
    </li>
  `;

  $list.on('init', function(event, slickInstance) {
    slickInstance.slickAdd(fakeSlide);
  });

  $list.slick({
    slidesToShow: 7.6,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow,
    nextArrow,
    variableWidth: false,
    centerMode: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 767,      
        settings: {
          slidesToShow: 2.7,    
          slidesToScroll: 3,
          arrows: false       
        }
      }
    ]
  });
};

// Ancienne version Slick pour les collections
window.initSlickCollections = function() {
  const $list = $('.slider-search__collections ul.aa-List');
  if (!$list.length || $list.hasClass('slick-initialized')) return;
  $list.slick({
    slidesToShow: 3.3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow,
    nextArrow,
    variableWidth: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 767,      
        settings: {
          slidesToShow: 2.3,
          arrows: false      
        }
      }
    ]
  });
};

// Ancienne version Slick pour les collections par catégorie
window.initSlickCollectionsCategories = function() {
  const $list = $('.aa-see__collections-category--contaner ul.aa-List');
  if (!$list.length || $list.hasClass('slick-initialized')) return;
  $list.slick({
    slidesToShow: 4.5,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow,
    nextArrow,
    variableWidth: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 767,      
        settings: {
          slidesToShow: 2.3,
          arrows: false      
        }
      }
    ]
  });
};

// Ancienne version Slick pour les collections results
window.initSlickCollectionsResults = function() {
  const $list = $('.slider-search__collections-results ul.aa-List');
  if (!$list.length || $list.hasClass('slick-initialized')) return;
  $list.slick({
    slidesToShow: 4.5,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow,
    nextArrow,
    variableWidth: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 767,      
        settings: {
          slidesToShow: 2.3,
          arrows: false       
        }
      }
    ]
  });
};
*/

// ============================================================================
// FONCTIONS UTILITAIRES
// ============================================================================

// Fonction pour créer ou récupérer une scrollbar personnalisée
function createCustomScrollbar(containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const parent = container.parentElement;
  if (!parent) return;

  const needsScroll = container.scrollWidth > container.clientWidth;
  const isDesktop = window.innerWidth >= 768;
  
  if (!needsScroll || !isDesktop) {
    const existingScrollbar = parent.querySelector('.custom-scrollbar');
    if (existingScrollbar) {
      existingScrollbar.remove();
    }
    return;
  }

  let scrollbar = parent.querySelector('.custom-scrollbar');
  if (!scrollbar) {
    scrollbar = document.createElement('div');
    scrollbar.className = 'custom-scrollbar';
    scrollbar.innerHTML = '<div class="custom-scrollbar-progress"></div>';
    parent.appendChild(scrollbar);
  }

  const progress = scrollbar.querySelector('.custom-scrollbar-progress');
  if (!progress) return;

  const updateProgress = () => {
    const maxScroll = container.scrollWidth - container.clientWidth;
    const isDesktop = window.innerWidth >= 768;
    
    if (maxScroll <= 0 || !isDesktop) {
      scrollbar.style.display = 'none';
      return;
    }

    scrollbar.style.display = 'block';
    const scrollPercent = (container.scrollLeft / maxScroll) * 100;
    progress.style.left = (scrollPercent * 0.5) + '%';
  };

  let timeout;
  const throttledUpdate = () => {
    if (timeout) return;
    timeout = requestAnimationFrame(() => {
      updateProgress();
      timeout = null;
    });
  };

  container.addEventListener('scroll', throttledUpdate);
  window.addEventListener('resize', throttledUpdate);

  scrollbar.addEventListener('click', (e) => {
    if (e.target === progress) return;
    
    const rect = scrollbar.getBoundingClientRect();
    const clickPercent = ((e.clientX - rect.left) / rect.width) * 100;
    const maxScroll = container.scrollWidth - container.clientWidth;
    
    container.scrollLeft = (clickPercent / 100) * maxScroll;
  });

  updateProgress();
}

// ============================================================================
// FONCTIONS PRINCIPALES (VERSIONS CSS PUR)
// ============================================================================

// Initialise le carousel des produits best sellers (version CSS pure)
window.initSlickProducts = function() {
  const $list = $('.slider-search__best-sellers ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  if (!$list.find('.aa-ProductItem--view-all').length) {
    const fakeSlide = `
      <li class="aa-Item">
        <div class="aa-ProductItem aa-ProductItem--view-all">
          <a href="/search" class="aa-ProductLink">
            <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <g clip-path="url(#clip0_2457_3667)">
                <path d="M23.8628 5.68132C24.4873 5.68132 25 5.16856 25 4.54397V3.40934C25 1.53284 23.4646 0 21.591 0H7.95244C6.07614 0 4.54347 1.53284 4.54347 3.40934V4.54669H3.40897C1.53267 4.54669 0 6.07953 0 7.95603V21.5934C0 23.4699 1.53267 25.0027 3.40897 25.0027H17.0448C18.9211 25.0027 20.4538 23.4699 20.4538 21.5934V20.456H21.591C23.4673 20.456 25 18.9232 25 17.0467V9.09339C25 8.4688 24.4873 7.95603 23.8628 7.95603C23.2382 7.95603 22.7255 8.4688 22.7255 9.09339V17.0494C22.7255 17.674 22.2128 18.1868 21.5883 18.1868H7.95244C7.32792 18.1868 6.81521 17.674 6.81521 17.0494V3.40934C6.81521 2.78475 7.32792 2.27198 7.95244 2.27198H21.5883C22.2128 2.27198 22.7255 2.78475 22.7255 3.40934V4.54669C22.7255 5.17128 23.2355 5.68132 23.86 5.68132H23.8628ZM7.95244 20.456H18.1793V21.5934C18.1793 22.218 17.6666 22.7307 17.0421 22.7307H3.40897C2.78444 22.7307 2.27174 22.218 2.27174 21.5934V7.9533C2.27174 7.32871 2.78444 6.81595 3.40897 6.81595H4.5462V17.044C4.5462 18.9205 6.07887 20.4533 7.95517 20.4533L7.95244 20.456ZM13.6359 14.2047V11.3626H10.7942C10.1696 11.3626 9.65692 10.8499 9.65692 10.2253C9.65692 9.6007 10.1696 9.08793 10.7942 9.08793H13.6359V6.24591C13.6359 5.62132 14.1486 5.10855 14.7731 5.10855C15.3976 5.10855 15.9103 5.62132 15.9103 6.24591V9.08793H18.752C19.3766 9.08793 19.8893 9.6007 19.8893 10.2253C19.8893 10.8499 19.3766 11.3626 18.752 11.3626H15.9103V14.2047C15.9103 14.8293 15.3976 15.342 14.7731 15.342C14.1486 15.342 13.6359 14.8293 13.6359 14.2047Z" fill="#1E1E1E" fill-opacity="0.4"/>
              </g>
              <defs>
                <clipPath id="clip0_2457_3667">
                  <rect width="25" height="25" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div class="aa-ProductTitle">Voir tous les produits</div>
          </a>
        </div>
      </li>
    `;
    $list.append(fakeSlide);
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.slider-search__best-sellers ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des produits best sellers results (version CSS pure)
window.initSlickProductsResults = function() {
  const $list = $('.slider-search__best-sellers-results ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  if (!$list.find('.aa-ProductItem--view-all').length) {
    const fakeSlide = `
      <li class="aa-Item">
        <div class="aa-ProductItem aa-ProductItem--view-all">
          <see-all-button section="showBestSellers150" class="aa-ProductLink">
            <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <g clip-path="url(#clip0_2457_3667)">
                <path d="M23.8628 5.68132C24.4873 5.68132 25 5.16856 25 4.54397V3.40934C25 1.53284 23.4646 0 21.591 0H7.95244C6.07614 0 4.54347 1.53284 4.54347 3.40934V4.54669H3.40897C1.53267 4.54669 0 6.07953 0 7.95603V21.5934C0 23.4699 1.53267 25.0027 3.40897 25.0027H17.0448C18.9211 25.0027 20.4538 23.4699 20.4538 21.5934V20.456H21.591C23.4673 20.456 25 18.9232 25 17.0467V9.09339C25 8.4688 24.4873 7.95603 23.8628 7.95603C23.2382 7.95603 22.7255 8.4688 22.7255 9.09339V17.0494C22.7255 17.674 22.2128 18.1868 21.5883 18.1868H7.95244C7.32792 18.1868 6.81521 17.674 6.81521 17.0494V3.40934C6.81521 2.78475 7.32792 2.27198 7.95244 2.27198H21.5883C22.2128 2.27198 22.7255 2.78475 22.7255 3.40934V4.54669C22.7255 5.17128 23.2355 5.68132 23.86 5.68132H23.8628ZM7.95244 20.456H18.1793V21.5934C18.1793 22.218 17.6666 22.7307 17.0421 22.7307H3.40897C2.78444 22.7307 2.27174 22.218 2.27174 21.5934V7.9533C2.27174 7.32871 2.78444 6.81595 3.40897 6.81595H4.5462V17.044C4.5462 18.9205 6.07887 20.4533 7.95517 20.4533L7.95244 20.456ZM13.6359 14.2047V11.3626H10.7942C10.1696 11.3626 9.65692 10.8499 9.65692 10.2253C9.65692 9.6007 10.1696 9.08793 10.7942 9.08793H13.6359V6.24591C13.6359 5.62132 14.1486 5.10855 14.7731 5.10855C15.3976 5.10855 15.9103 5.62132 15.9103 6.24591V9.08793H18.752C19.3766 9.08793 19.8893 9.6007 19.8893 10.2253C19.8893 10.8499 19.3766 11.3626 18.752 11.3626H15.9103V14.2047C15.9103 14.8293 15.3976 15.342 14.7731 15.342C14.1486 15.342 13.6359 14.8293 13.6359 14.2047Z" fill="#1E1E1E" fill-opacity="0.4"/>
              </g>
              <defs>
                <clipPath id="clip0_2457_3667">
                  <rect width="25" height="25" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div class="aa-ProductTitle">Voir tous les produits</div>
          </see-all-button>
        </div>
      </li>
    `;
    $list.append(fakeSlide);
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.slider-search__best-sellers-results ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des produits no results (version CSS pure)
window.initSlickProductsNoResults = function() {
  const $list = $('.aa-noresults-products-container ol.ais-Hits-list');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.aa-noresults-products-container ol.ais-Hits-list.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des collections (version CSS pure)
window.initSlickCollections = function() {
  const $list = $('.slider-search__collections ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.slider-search__collections ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des collections par catégorie (version CSS pure)
window.initSlickCollectionsCategories = function() {
  const $list = $('.aa-see__collections-category--contaner ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.aa-see__collections-category--contaner ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des collections results (version CSS pure)
window.initSlickCollectionsResults = function() {
  const $list = $('.slider-search__collections-results ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.slider-search__collections-results ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des collections no results (version CSS pure)
window.initSlickCollectionsNoResults = function() {
  const $list = $('.aa--noresults-collections-container ol.ais-Hits-list');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.aa--noresults-collections-container ol.ais-Hits-list.css-scroll-horizontal');
  }, 100);
};

// Initialise le carousel des collections dans les résultats de recherche (version CSS pure)
window.initSlickResultCollections = function() {
  const $list = $('.slider-result__collections ul.aa-List');
  if (!$list.length) return;
  
  if ($list.hasClass('slick-initialized')) {
    $list.slick('unslick');
    $list.removeClass('slick-initialized slick-slider');
    $list.find('.slick-slide').unwrap();
    $list.find('.slick-list').contents().unwrap();
    $list.find('.slick-track').contents().unwrap();
  }
  
  $list.addClass('css-scroll-horizontal');
  
  setTimeout(() => {
    createCustomScrollbar('.slider-result__collections ul.aa-List.css-scroll-horizontal');
  }, 100);
};

// ============================================================================
// FONCTIONS SPÉCIALES
// ============================================================================

// Initialise Slick pour les recherches fréquentes (version hybride)
window.initSlickFrequentSearches = function() {
  const $list = $('.aa-SourcefrequentSearches ul.aa-List');
  if (!$list.length) return;

  function handleSlick() {
    const isMobile = window.innerWidth <= 767;

    if (isMobile && !$list.hasClass('slick-initialized')) {
      $list.slick({
        slidesToShow: 4.1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        variableWidth: true,
        centerMode: false,
      });
    }
    else if (!isMobile && $list.hasClass('slick-initialized')) {
      $list.slick('unslick');
    }
  }

  $(window).on('load resize', handleSlick);
  handleSlick();
};